
  import JobDetailsData from '@/components/JobDetailsData';
  import LazyHydrate from 'vue-lazy-hydration';
  import InactiveJobNotificationBox from '@/components/InactiveJobNotificationBox';
  import JobBoxSimilarOffers from '@/components/elements/JobBoxSimilarOffers';
  import ScreenSize from '@/mixins/ScreenSize';

  export default {
    components: {
      LazyHydrate,
      JobDetailsData,
      InactiveJobNotificationBox,
      TeaseredArticlesCard: () =>
        import('@/components/elements/TeaseredArticlesCard'),
      SendViaEmail: () => import('@/components/SendViaEmail'),
      JobBoxSimilarOffers,
    },
    mixins: [ScreenSize],
    props: {
      section: {
        type: Object,
        required: true,
        default: () => {},
      },
      jobPosting: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
  };
